import axios from "axios";
import { message } from "antd";
import * as Sentry from "@sentry/react";
const BASE_URL = process.env.REACT_APP_BASE_URL;
// const BASE_URL = "http://localhost:3000";

const api = axios.create({
  baseURL: BASE_URL,
});

const current = (skipAuth = false) => {
  const currentAPI = api;

  const requestInterceptorId = currentAPI.interceptors.request.use(
    async (config) => {
      if (skipAuth) {
        return config;
      }
      const accessToken = window.localStorage.getItem("aptoken");

      if (accessToken) {
        config.params = {
          token: accessToken,
        };
      }

      return config;
    }
  );

  return () => {
    currentAPI.interceptors.request.eject(requestInterceptorId);
    //currentAPI.interceptors.response.eject(responseInterceptorId);
  };
};

const response = () => {
  const currentAPI = api;
  currentAPI.interceptors.response.use(
    function (response) {
      if (response.data.status === 2) {
        window.localStorage.removeItem("aptoken");
        localStorage.clear();
        message.error(response.data.message);

        setTimeout(() => {
          window.location.assign("/");
        }, 2000);
      }

      return response;
    },
    function (error) {
      if (error.response) {
        const url =
          error.config?.baseURL && error.config?.url
            ? `${error.config.baseURL}${error.config.url}`
            : error.config?.url || "unknown";
        console.error(
          `[API] ${error.response.status} ${error.response.statusText}:`,
          error.config?.method?.toUpperCase() || "GET",
          url,
          error.response.data || ""
        );
      } else {
        const isNetworkError =
          error.code === "ERR_NETWORK" || error.message === "Network Error";
        if (isNetworkError) {
          message.error(
            "Unable to reach the server. Check your connection and that the API is running, or try again later."
          );
          console.error("[API] Network error:", error.message, error.config?.url || "");
        }
      }

      Sentry.captureException(error);

      return Promise.reject(error);
    }
  );
};

current();
response();

export default api;
